import styled from 'styled-components';

export const ContributionContents = styled.div`
  display: flex;
  img {
    width: 90px;
    display: flex;
    align-self: flex-start;
  }
`;

export const ContributionContent = styled.div`
  height: 100%;
  padding-left: 20px;
  z-index: 5;
  p {
    margin-bottom: 15px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-bottom: 5px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 767px) {
    padding-left: 15px;
  }
`;

export const DownloadDescription = styled.p`
  font-size: 24px;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 0.5px;
  margin: 0;
  color: #022737;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: 20px;
  }
`;

export const DownloadTag = styled.a`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.tableFont};
  text-decoration: underline;
  cursor: pointer;
  @media only screen and (min-width: 320px) and (max-width: 529px) {
    font-size: 14px;
  }
  &:hover {
    color: #006778;
    text-decoration: underline;
  }
`;